import EditLuceEGasPage from "@/views/CMS/LuceEGas/EditLuceEGasPage.vue";
const routes = [
    {
        path: "/cms/luce-e-gas/edit/",
        name: "EditLuceEGasPage",
        component: EditLuceEGasPage,
    },
];
export default routes;
